module.exports = __webpack_public_path__ + "img/icon-notif.b9bf2a00.svg";